import React from 'react';

const CreateProductPage = () => (
  <div>
    <h1>Create Product</h1>
    <p>This page is a stub for the legacy design creation flow.</p>
  </div>
);

export default CreateProductPage;
